var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"mainError"},[_c('h1',{staticClass:"display-5"},[_vm._v("Error 404")]),_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-2)}}},[_vm._v("\n    back\n  ")]),_c('hr',{}),_c('h2',[_vm._v("Seite nicht gefunden "+_vm._s(_vm.$route.params.error))])])
}
var staticRenderFns = []

export { render, staticRenderFns }